import { IntlShape } from "react-intl";
import { Column } from "react-table";

import Badge from "components/atoms/Badge/Badge";
import { DateTimeFormat, formatDate } from "helpers/dateTimeHelper";
import { formatNumber } from "helpers/commonHelpers";

const getRateCardColumns = (intl: IntlShape): Column[] => [
  {
    Header: intl.formatMessage({
      id: "general.name",
      defaultMessage: "Name",
    }),
    accessor: "name",
    sortable: true,
    Cell: ({ value }: any) => <div>{value || "-"}</div>,
  },
  {
    Header: intl.formatMessage({
      id: "general.provider",
      defaultMessage: "Provider",
    }),
    accessor: "provider",
    sortable: true,
    Cell: ({ value }: any) => <div>{value || "-"}</div>,
  },
  {
    Header: intl.formatMessage({
      id: "general.freightMode",
      defaultMessage: "Freight mode",
    }),
    accessor: "freight_mode",
    Cell: ({ value }: any) => <div>{value || "-"}</div>,
  },
  {
    Header: intl.formatMessage({
      id: "settings.rate-cards.startDate",
      defaultMessage: "Start Date",
    }),
    accessor: "rate_card_start_date",
    sortable: true,
    Cell: ({ value }: any) => <div>{formatDate(value, DateTimeFormat.dateFormat) || "-"}</div>,
  },
  {
    Header: intl.formatMessage({
      id: "settings.rate-cards.expiryDate",
      defaultMessage: "Expiry Date",
    }),
    accessor: "rate_card_expiration",
    sortable: true,
    Cell: ({ value }: any) => <div>{formatDate(value, DateTimeFormat.dateFormat) || "-"}</div>,
  },
  {
    Header: intl.formatMessage({
      id: "settings.rate-cards.laneOrigin",
      defaultMessage: "Lane - Origin",
    }),
    accessor: "lane_origin",
    Cell: ({ value }: any) => <div>{value || "-"}</div>,
  },
  {
    Header: intl.formatMessage({
      id: "settings.rate-cards.laneDestination",
      defaultMessage: "Lane - Destination",
    }),
    accessor: "lane_destination",
    Cell: ({ value }: any) => <div>{value || "-"}</div>,
  },
  {
    Header: intl.formatMessage({
      id: "general.status",
      defaultMessage: "Status",
    }),
    accessor: "is_active",
    Cell: ({ value }: any) => (
      <div className="d-flex">
        <Badge
          label={
            value
              ? intl.formatMessage({
                  id: "general.active",
                  defaultMessage: "Active",
                })
              : intl.formatMessage({
                  id: "general.inActive",
                  defaultMessage: "Inactive",
                })
          }
          type={value ? "primary" : "danger"}
        />
      </div>
    ),
  },
  // Additional Columns
  {
    Header: intl.formatMessage({
      id: "settings.rate-cards.dangerousGoods",
      defaultMessage: "Dangerous goods",
    }),
    accessor: "is_dangerous_goods",
    Cell: ({ value }: any) => <div>{value ? "Yes" : "No" || "-"}</div>,
  },
  {
    Header: intl.formatMessage({
      id: "settings.rate-cards.incoterms",
      defaultMessage: "Incoterms",
    }),
    accessor: "incoterms",
    Cell: ({ value }: any) => (
      <div style={{ maxWidth: 200, textOverflow: "ellipsis", overflow: "hidden" }} title={value?.join("\n")}>
        {value?.join(", ") || "-"}
      </div>
    ),
  },
  {
    Header: intl.formatMessage({
      id: "settings.rate-cards.pickupLeadTimeDay",
      defaultMessage: "Pick Up Lead Time (day)",
    }),
    accessor: "pickup_lead_time_in_days",
    Cell: ({ value }: any) => <div>{value || "-"}</div>,
  },
  {
    Header: intl.formatMessage({
      id: "settings.rate-cards.deliveryLeadTimeDay",
      defaultMessage: "Delivery Lead Time (day)",
    }),
    accessor: "delivery_lead_time_in_days",
    Cell: ({ value }: any) => <div>{value || "-"}</div>,
  },
  {
    Header: intl.formatMessage({
      id: "settings.rate-cards.metricShippingFactor",
      defaultMessage: "Metric Shipping Factor",
    }),
    accessor: "metric_shipping_factor",
    Cell: ({ value }: any) => <div>{formatNumber(value) || "-"}</div>,
  },
  {
    Header: intl.formatMessage({
      id: "settings.rate-cards.charge_type",
      defaultMessage: "Charge Type",
    }),
    accessor: "lcl_charge_type",
    Cell: ({ value }: any) => <div>{value || "-"}</div>,
  },
  {
    Header: intl.formatMessage({
      id: "settings.rate-cards.tonnePerCBM",
      defaultMessage: "Tonne Per CBM",
    }),
    accessor: "tonne_per_cbm",
    Cell: ({ value }: any) => <div>{value || "-"}</div>,
  },
  {
    Header: intl.formatMessage({
      id: "new-request.service.serviceRequirement",
      defaultMessage: "Service Requirements",
    }),
    accessor: "service_requirement",
    Cell: ({ value }: any) => (
      <div style={{ maxWidth: 200, textOverflow: "ellipsis", overflow: "hidden" }} title={value?.join("\n")}>
        {value?.join(", ") || "-"}
      </div>
    ),
  },
];

export default getRateCardColumns;
